module.exports = {
      id: "ic-highest-lowest-dark-normal-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-highest-lowest-dark-normal-usage",
      toString: function () {
        return this.url;
      }
    }